import { createFileRoute, redirect } from '@tanstack/react-router'
import { Select, Trans, useLingui } from '@lingui/react/macro'
import { AddSelfExclusionRequestType } from '@/features/self-exclusion/types'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { AccessControlsConfirmation } from '../_app/your-play.access-controls/-confirmation/access-controls-confirmation'
import { getPlayerSession } from '@/features/player-session'

const searchSchema = z.object({
  validTo: z.string().datetime(),
  type: z.enum([
    'HALF_YEAR',
    'YEAR',
    'INDEFINITE',
    'TEST_20_SEC',
    'TEST_5_MIN',
  ]),
})

export const Route = createFileRoute('/self-exclusion-confirmation')({
  component: SelfExclusionConfirmation,
  validateSearch: zodValidator(searchSchema),
  beforeLoad: async () => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      return redirect({ to: '/' })
    }
  },
})

function SelfExclusionConfirmation() {
  const { i18n } = useLingui()
  const search = Route.useSearch()
  const date = i18n.date(search.validTo, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })

  return (
    <AccessControlsConfirmation
      heading={<Trans>You have successfully set a Self-exclusion</Trans>}
      description={
        <>
          {search.type === 'INDEFINITE' ? (
            <Trans>Your indefinite Self-exclusion has started.</Trans>
          ) : (
            <Trans>
              Your{' '}
              <Select
                value={search.type as AddSelfExclusionRequestType}
                _HALF_YEAR="6 months"
                _YEAR="1 year"
                other=""
              />{' '}
              Self-exclusion has started and will end on {date}
            </Trans>
          )}
        </>
      }
    />
  )
}
